// Copyright (c) 2024-2025, Brandon Lehmann <brandonlehmann@gmail.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

// eslint-disable-next-line import/no-named-default
import type { default as SimpleWebAuthnBrowser } from '@simplewebauthn/browser';
import { version, JSDELIVR } from '../helpers/cdn';

declare global {
    interface JQueryStatic {
        /**
         * The @simplewebauthn/browser module interface
         *
         * See: https://simplewebauthn.dev/docs/packages/browser
         */
        webauthn(): typeof SimpleWebAuthnBrowser;
    }

    interface Window {
        SimpleWebAuthnBrowser: typeof SimpleWebAuthnBrowser;
    }
}

($ => {
    const setup = () => {
        $.webauthn = () => window.SimpleWebAuthnBrowser;
    };

    if (typeof window.SimpleWebAuthnBrowser === 'undefined') {
        $.getScript({
            // eslint-disable-next-line max-len
            url: `${JSDELIVR}/@simplewebauthn/browser@${version('@simplewebauthn/browser')}/dist/bundle/index.umd.min.js`,
            cache: true,
            success: () => setup()
        });
    } else {
        setup();
    }
})(window.$);

export {};
